import { SERVICE_PROVIDERS } from 'modules/graphql';
import {
  SendingPlatform,
  ServiceProvidersBySendingPlatform,
  ConfigurableSendingPlatforms,
} from '../../constants';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../types';
import { DEFAULT_VALUES } from './constants';

export const createDefaultValues = (
  sendingPlatform: SendingPlatform,
  espDefinitions: SERVICE_PROVIDERS[],
) => {
  const defaultValues = DEFAULT_VALUES[sendingPlatform as ConfigurableSendingPlatforms];
  const esps = ServiceProvidersBySendingPlatform[sendingPlatform];
  const defaultEsp = esps.find((esp) => espDefinitions.includes(esp)) || esps[0];
  return { ...defaultValues, [ESP_ACCOUNT_PAYLOAD_FIELDS.ESP]: defaultEsp };
};
